module.exports = __webpack_public_path__ + "static/tv-b2b64149557af856c24b94b627cf0118.png";